import { files } from "@/firebase.js";
import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    list: [],
    listLoading: false
  },
  mutations: {
    setList(state, rock7s) {
      state.list = rock7s;
    },
    setListLoading(state, loading) {
      state.listLoading = loading;
    }
  },
  actions: {
    async loadAll({ commit, dispatch, rootState }) {
      commit("setListLoading", true);

      let rock7s = await api.get("events/rock7/getData");

      commit("setList", rock7s.data);
      commit("setListLoading", false);
      dispatch("loadTriggers");
    }
  },
  getters: {
    listLoading(state) {
      return state.listLoading;
    },
    list(state) {
      return state.list;
    }
  }
};
